module.exports = __webpack_public_path__ + "static/img/storageFu3.af3ade8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storageFu3.png
// module id = 5/Kx
// module chunks = 2